import React, { useMemo, Fragment, useState, useEffect, useReducer } from 'react';
import { useNavigate } from 'react-router-dom';
import { formatPhoneNumber } from '../../../utils/helpers'
import ButtonComponent from "../../../commons/components/Forms/ButtonComponent";
import DialogComponent from "../../../commons/components/Modal/DialogComponent";

const GENDER = {
  M: "남자",
  F: "여자",
}

const AwardRegisterForm = ({
  name,
  childrens,
  photoSelected,
  goToChildren,
  goToAlbum,
  handleSubmit,
  loading,
  errors,
  initData,
}) => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    contact_phone: '',
    children_id: null,
    photo_id: null,
  })
  const [formError, setFormError] = useState({})
  const [confirmModal, setConfirmModal] = useReducer(p => !p, false)

  useEffect(() => {
    if (initData) {
      setFormData(p => ({...p, ...initData}))
    }
  }, [initData])

  useEffect(() => {
    if (photoSelected) {
      setFormData(p => ({
        ...p,
        photo_id: photoSelected?.id
      }))
    }
  }, [photoSelected])

  useEffect(() => {
    if (childrens.length && !childrens.map(e => +e.id).includes(+formData?.children_id)) {
      setFormData(p => ({
        ...p,
        children_id: childrens[0].id
      }))
    }
  }, [childrens, initData])

  useEffect(() => {
    if (errors) {
      let er = {}
      Object.keys(errors).map((key) => {
        er[key] = errors[key][0]
      })
      setFormError(er)
    } else {
      setFormError({})
    }
  }, [errors])

  const _handleChangeData = e => {
    let name = e.target.name
    let value = e.target.value

    if (value && name === 'contact_phone') {
      value = value.replaceAll('-','')
      const re = /^[0-9\b]+$/;
      if (value.length > 11 || !re.test(value)) {
        return;
      }
    }
    setFormData(p => ({
      ...p,
      [name]: name === 'contact_phone' ? formatPhoneNumber(value) : value
    }))
    let errors = {...formError}
    delete errors[e.target.name]
    setFormError(errors)
  }

  const showConfirmPopup = () => {
    let isError = false
    let errors = {}
    const contact_phone = formData.contact_phone.replaceAll('-','')
    if (!formData.contact_phone) {
      errors = {...errors, contact_phone: '전화번호를 입력해주세요'}
      isError = true
    } else if (contact_phone.length < 11) {
      errors = {...errors, contact_phone: '11자리 전화번호를 입력해주세요.'}
      isError = true;
    }
    if (!formData.photo_id) {
      errors = {...errors, photo_id: '사진을 등록해주세요'}
      isError = true
    }
    if (isError) {
      setFormError(errors)
      return
    }
    setConfirmModal()
  }

  const _handleSubmit = () => {
    handleSubmit({
      children_id: formData.children_id,
      photo_id: formData.photo_id,
      contact_phone: (formData.contact_phone ?? '') // .replaceAll('-','')
    })
    setConfirmModal()
  }

  const _goToAlbum = () => {
    goToAlbum(formData)
  }

  const _goToChildren = () => {
    goToChildren(formData)
  }

  return (
    <Fragment>
      <form className="award-signup-form">
        <div className="input-component disnabled">
          <label className="required">닉네임</label>
          <div className="input-group">
            <input type="text" placeholder={name} />
          </div>
          <label className="award-signup-form__note">
            * 닉네임은 내 정보에서 수정 가능합니다.
          </label>
        </div>
        <div className="input-component">
          <label className="required">연락처</label>
          <div className="input-group">
            <input
              type="text"
              className={formError.contact_phone ? 'form-control-error' : ''}
              placeholder="상품 수령을 위한 연락처를 입력해주세요."
              name="contact_phone"
              value={formData.contact_phone}
              onChange={_handleChangeData}
            />
            {formError.contact_phone && 
              <span className="input-error show">{formError.contact_phone}</span>
            }
          </div>
          <label className="award-signup-form__note">
            * 정보 오기입으로 인해 선물이 미전달 될 경우 스포키즈에서 책임지지 않습니다.
          </label>
        </div>
        <div className="input-component d-flex justify-content-between m-0">
          <label className="required m-0">아이 정보</label>
          <button className="btn btn-register-new" onClick={_goToChildren}>
            <img src="/images/icon_plus.svg" />
            <label>새 아이 정보 등록</label>
          </button>
        </div>
        {childrens.length ? (
          <Fragment>
            <div className="group-choose-radio d-flex justify-content-between m-0 flex-wrap">
              {childrens.map((child) => (
                <label className={`radio-component m-0 mt-2`} key={child.id}>
                  <div className="radio">
                    <input
                      type="radio"
                      name="children_id"
                      value={child.id}
                      checked={child.id == formData.children_id}
                      onChange={_handleChangeData}
                    />
                    <span></span>
                  </div>
                  <div className="label">
                    <p>{child.age}년생 / {GENDER[child.gender]}</p>
                  </div>
                </label>
              ))}
            </div>
            <label className="award-signup-form__note mb-3">
              * 한 아이디당 한명의 아이만 등록이 가능합니다!
            </label>
          </Fragment>
        ) : (
          <div className="input-component disnabled mt-2">
            <div className="input-group">
              <input type="text" placeholder="등록되어있는 아이 정보가 없습니다." />
            </div>
            <label className="award-signup-form__note">
              * 한 아이디당 한명의 아이만 등록이 가능합니다!
            </label>
          </div>
        )}
        {formError.children_id && 
          <span className="input-error show">{formError.children_id}</span>
        }
        <div className="input-component">
          <label className={`required ${formError.photo_id ? 'd-block mb-0' : ''}`}>
            사진 등록
          </label>
          {formError.photo_id && 
            <span className="input-error show mt-0 mb-2">{formError.photo_id}</span>
          }
          <div className="award-signup-form__upload" onClick={_goToAlbum}>
            <img
              className={photoSelected?.photo_url?.thumbnail ? "award-signup-form__upload_img" : "award-signup-form__upload_default"}
              src={photoSelected?.photo_url?.thumbnail ?? "/images/icon_imageadd.svg"}
            />
          </div>
          <label className="award-signup-form__note mb-0">
              <p className="mb-1">* 스포키즈 오프라인 키오스크 및 앱 내에서 캐릭터 셀카로 찍은</p>
              <p className="m-0">사진만 참여 등록 가능합니다.</p>
            </label>
        </div>
        <ButtonComponent
          cssClass={"btn btn-block btn-primary award-signup-form__submit"}
          label={<>참여등록</>}
          type={"button"}
          disabled={false}
          loadingBtn={loading}
          handleClick={showConfirmPopup}
        />
      </form>
      <DialogComponent
        id={"MD4"}
        show={confirmModal}
        title={'정보확인'}
        closeBtn={"취소"}
        customBtn={"확인"}
        handleClose={setConfirmModal}
        handleCustom={_handleSubmit}
        className="award-signup-confirm"
      >
        <div className="info">
          <p className="word-break-all mb-1"><span>닉네임</span> {name}</p>
          <p className="word-break-all mb-0"><span>연락처</span> {formData.contact_phone}</p>
        </div>
        <p className="content">입력하신 정보로 참여등록을 진행하시겠습니까?</p>
        <p className="note">부적절한 이미지를 등록했을 경우 경고없이 삭제됩니다.</p>
      </DialogComponent>
    </Fragment>
  );
};

export default AwardRegisterForm;
